










































import Vue, { PropType } from 'vue';
import TableHeadCell from '@/components/table/newTable/TableHeadCell.vue';
import TableBodyCell from '@/components/table/newTable/TableBodyCell.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import TableService from '@/services/TableService';
import { TTableColumns } from '../types';
import { getTranslate } from '@/helpers/translateHelpers';

//TODO: Сделать смену дизайна таблицы (default | light) стилями
export default Vue.extend({
  name: 'Table',
  components: {
    TableHeadCell,
    TableBodyCell,
    Preloader,
  },

  props: {
    columnsData: {
      type: Array as PropType<TTableColumns>,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    styleType: {
      type: String,
      required: false,
      default: 'default',
    },
    loadData: {
      type: Boolean,
      required: false,
      default: false,
    },
    //TODO: Придумать фунционал, сейчас параметр просто добавляет визуальное выделение строки тенями при наведении мыши
    selectRow: {
      type: Boolean,
      required: false,
      default: false,
    },
    emptyMessage: {
      type: String,
      required: false,
      default: getTranslate('notifications.noData'),
    },
  },

  watch: {
    columnsData: {
      handler(newValue: TTableColumns) {
        this.columns = newValue;
      },
      immediate: true,
    },
    sortedColumn() {
      this.changeSort();
    },
  },

  computed: {
    visibleColumns(): TTableColumns {
      return TableService.filterColumnsByVisible(this.columns);
    },
  },

  methods: {
    updateSortColumn(sortedColumn: string) {
      this.sortedColumn = sortedColumn;
    },
    changeSort() {
      this.$emit('changeSort', this.sortedColumn);
    },
  },

  data() {
    return {
      columns: [] as TTableColumns,
      sortedColumn: '',
    };
  },
});
